/* @flow */

import { get } from 'lodash/fp';
import styled from '@emotion/styled';
import { connect } from 'react-redux';

const Heading = styled.div(
  ({ theme }) => ({
    alignItems: 'center',
    backgroundImage: `linear-gradient(to bottom, ${theme.color.widgetSecondary}, ${theme.color.widgetPrimary})`,
    color: 'white',
    display: 'flex',
    fontSize: '0.9em',
    justifyContent: 'center',
    padding: '0 0.5em',
    textAlign: 'center'
  }),
  ({ separate }) =>
    separate
      ? {
          borderRight: '1px solid white'
        }
      : undefined
);

function mapStateToProps(state, ownProps) {
  const { columnIndex, style, categories, expanded } = ownProps;

  return {
    children: get(expanded ? 'shortName' : 'abbr')(categories[columnIndex]),
    style
  };
}

export default connect(mapStateToProps)(Heading);
